/* eslint-disable */

const ruCollator = new Intl.Collator("ru-RU");

export { ruCollator };